import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';

import { submitForm } from '../../../store/api/submitForm/submitForm';
import { EditTppResponse, TppsResponse } from '../../../store/api/tpps/tpps.types';
import { editTpp, fetchTpps } from '../../../store/api/tpps/tppsActions';

import { Tpps } from './Tpps';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onEditTpp: submitForm<EditTppResponse>(dispatch, editTpp),
  onFetchTpps: () => dispatch<Promise<TppsResponse>>(fetchTpps()),
});

export const TppsContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Tpps);
